var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatus100 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 4.5C16.1421 4.5 19.5 7.85786 19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12C4.5 7.85786 7.85786 4.5 12 4.5ZM16.374 9.21973C16.0811 8.92695 15.6063 8.92687 15.3135 9.21973L11.3979 13.1367L9.22998 10.9688C8.93707 10.6765 8.46214 10.6761 8.16943 10.9688C7.87674 11.2614 7.87712 11.7364 8.16943 12.0293L10.8677 14.7275C11.0083 14.8678 11.1993 14.9473 11.3979 14.9473C11.5966 14.9471 11.7877 14.868 11.9282 14.7275L16.374 10.2803C16.6669 9.98738 16.6669 9.51262 16.374 9.21973Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatus100);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/status-100.e3225efd99dd3313bc2d128def49ca2b.svg";